import { useContext } from 'react';

import { INTERNAL_USER_ROLES, UserRoleEnum } from '@app/user/constants';

import { AuthContext } from '../context';
import { State } from '../types/State';

export const useAuth = () => {
  const { state, updateState } = useContext(AuthContext);

  const user = state?.user as State['user'];

  const isInternal = !!user && INTERNAL_USER_ROLES.includes(user.role);

  const isSuperAdmin = !!user && user.role === UserRoleEnum.superAdmin;

  const isParent = !!user && user.role === UserRoleEnum.parent;

  const isSurrogate = !!user && user.role === UserRoleEnum.surrogate;

  // SAA-112 P-K — `application`/`questionnaire` stay "the SELECTED one": every existing consumer of
  // `useAuth().application` keeps working unchanged. Only the selection rule changes: most-recent
  // by `createdAt` by default (AC 3.4), or whichever the switcher picked (`state.selectedXId`).
  const applications = [...(user?.applications ?? [])].sort(
    (a, b) => +new Date(b.createdAt ?? 0) - +new Date(a.createdAt ?? 0),
  );
  const questionnaires = [...(user?.questionnaires ?? [])].sort(
    (a, b) => +new Date(b.createdAt ?? 0) - +new Date(a.createdAt ?? 0),
  );

  const application = applications.find(a => a.id === state?.selectedApplicationId) ?? applications[0];
  const questionnaire = questionnaires.find(q => q.id === state?.selectedQuestionnaireId) ?? questionnaires[0];

  return {
    user,
    updateState,
    isInternal,
    isSuperAdmin,
    isParent,
    isSurrogate,
    applications,
    questionnaires,
    application,
    questionnaire,
    isSignedIn: !!state?.token,
  };
};
